import React from 'react';
import { FacebookIcon, InstagramIcon, LockIcon } from 'lucide-react';
const CONTACT_EMAIL = 'contactometodikaplus@gmail.com';
export function Footer() {
  return <footer className="bg-white px-5 py-8 sm:px-8" data-id="element-35" data-mp="3gh3rqfvjs8fo">
      <div className="mx-auto w-full max-w-content border-t border-line pt-8 text-center" data-id="element-36" data-mp="32ovz90bar3ms">
        <p className="font-display text-[17px] font-bold uppercase text-ink" data-id="element-37" data-mp="36qhgexuv642s">
          Libres de Ser © 2026
        </p>
        <p className="mt-1 font-sans text-[14px] uppercase tracking-[0.06em] text-ink-soft" data-id="element-38" data-mp="3ufjww2drhqvp">
          Producido por Metodika+
        </p>

        <nav aria-label="Redes sociales" className="mt-5 flex items-center justify-center gap-3" data-id="element-39" data-mp="3lec8qd4ym6fc">
          <a href="#facebook" aria-label="Facebook" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-coral transition-colors duration-150 ease-out hover:border-coral hover:bg-coral-soft/50" data-id="element-40" data-mp="3qcnlavmn2v19">
            <FacebookIcon aria-hidden="true" className="h-5 w-5" data-id="element-41" data-mp="3l9acngdir03d" />
          </a>
          <a href="#instagram" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-coral transition-colors duration-150 ease-out hover:border-coral hover:bg-coral-soft/50" data-id="element-42" data-mp="3lbdbmpwng3k8">
            <InstagramIcon aria-hidden="true" className="h-5 w-5" data-id="element-43" data-mp="3qapzndz9bgoe" />
          </a>
        </nav>

        <p className="mt-6 font-sans text-[13px] uppercase tracking-[0.06em] text-muted" data-id="element-44" data-mp="817dm6kejqu2">
          Contacto:
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="mt-1 inline-block break-all font-sans text-[14px] text-ink-soft underline decoration-line underline-offset-4 transition-colors duration-150 ease-out hover:text-coral" data-id="element-45" data-mp="322zr2mj94xe">
          {CONTACT_EMAIL}
        </a>

        <p className="mt-6 font-sans text-[13px] uppercase tracking-[0.06em] text-ink-soft" data-id="element-46" data-mp="qr5ikdswl3th">
          Respaldado por Avanza Pro LLC Company
        </p>

        <p className="mt-4 flex items-center justify-center gap-2 font-sans text-[13px] text-muted" data-id="element-47" data-mp="tw5wy2alzikm">
          <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-48" data-mp="yv90tjeurir0" />
          Plataforma segura · Pago 100% protegido
        </p>
      </div>
    </footer>;
}